import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito saber de tecnología para usar esto?',
    a: 'No. El Megapack está escrito para emprendedores que nunca usaron IA antes. Todo está en lenguaje simple, sin tecnicismos, con ejemplos de negocios argentinos reales. Si podés escribir un WhatsApp, podés usar este kit.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. 100% PDF. Después de tu compra en Mercado Pago recibís el acceso en menos de 5 minutos por email en el correo que registraste. Podés verlo en el celular, la tablet o la computadora. Sin apps especiales. Sin plataformas raras. Un PDF que abrís y usás.'
  }, {
    q: '¿Funciona para mi tipo de negocio?',
    a: 'Si tenés un negocio en Argentina que tiene clientes, vende algo y necesita comunicarse... este kit es para vos. Trabajamos con: Tiendas físicas y online, Servicios profesionales, Gastronomía y delivery, Artesanías y handmade, Educación y cursos, Salud y bienestar, Comercios y PyMEs, Emprendedores unipersonales.'
  }, {
    q: '¿Qué lo diferencia de un tutorial de YouTube?',
    a: 'Los tutoriales de YouTube enseñan la herramienta. Este kit enseña cómo usarla para tu negocio argentino específico. Diferencias concretas: Prompts ya construidos para casos argentinos, Ejemplos con WhatsApp, Instagram y MP, Contexto de inflación y economía local, Flujos completos, no tips sueltos, Sistema progresivo de 6 tomos conectados, Aplicable el mismo día que lo comprás.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días sin preguntas. Si en 7 días no es lo que esperabas, te devolvemos el 100%. Sin formularios. Sin esperas. Sin justificar nada. Menos del 1% de quienes lo compran piden devolución.'
  }, {
    q: '¿Se actualiza?',
    a: 'Sí. Las actualizaciones menores son sin costo adicional. La IA evoluciona rápido. Nos comprometemos a mantener el kit relevante y actualizado.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-86">
      <div className="text-center mb-12" data-id="element-87">
        <h2 className="text-3xl font-bold text-white mb-4" data-id="element-88">
          ❓ Lo que más nos preguntan
        </h2>
      </div>

      <div className="space-y-4" data-id="element-89">
        {faqs.map((faq, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-xl overflow-hidden" data-id="element-90">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" data-id="element-91">
              <span className="font-bold text-white" data-id="element-92">{faq.q}</span>
              <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-93" />
            </button>
            <AnimatePresence data-id="element-94">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} className="overflow-hidden" data-id="element-95">
                  <div className="px-6 pb-4 text-gray-300 text-sm leading-relaxed border-t border-white/5 pt-4" data-id="element-96">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}